<template>
  <div class="smart">
    <!-- banner部分 -->
    <div class="smart-banner clearfix">
      <div>
        <h2>智慧景区</h2>
        <h3>智慧导览系统</h3>
      </div>
    </div>
    <!-- 方案概述 -->
    <div class="container clearfix">
      <div class="smart-title">方案概述</div>
      <div class="smart-overview mb100">
        <!-- <div class="fl">
          <img src="../../../assets/img/smart/zhdp_summary_Image.png" alt="" />
        </div> -->
        <div>
          <h2>智慧导览系统</h2>
          <p>智慧导览系统是一种普及率广、认可率高，为大众广泛接受的信息导览形式。智慧导览结合景区景点分布情况，通过电子导览对景区场馆及其陈列历史文物等内容以图文并茂的方式展现给游客。游客在充分欣赏景区和展品外观的同时获得了丰富的知识，增强了旅游的趣味性。</p>
        </div>
      </div>
    </div>
    <!-- 方案优势 -->
    <div class="container clearfix">
      <div class="smart-title">方案优势</div>
      <ul class="smart-strength clearfix">
        <li>
          <h2>快速准确查看地图</h2>
          <p>景区电子地图一览无余，可查看景点图片、介绍等</p>
        </li>
        <li>
          <h2>位置信息实时掌握</h2>
          <p>提供实时游览位置信息，让游客省时又省力，提升景区服务质量</p>
        </li>
        <li>
          <h2>深度了解景区文化</h2>
          <p>挖掘各景点背后的故事，多语种、多风格语音讲解，满足游客的个性化需求</p>
        </li>
        <li>
          <h2>最佳线路推荐</h2>
          <p>推荐最佳旅游线路，选择最近、最省力、最省时的游览方式，提高旅游体验</p>
        </li>
        <li>
          <h2>一次投入持续受益</h2>
          <p>低碳环保，节省传统纸质导览图</p>
        </li>
        <li>
          <h2>提升旅游服务质量</h2>
          <p>为游客提供更加全面客观的服务，让游客更随意、更自由地享受旅游</p>
        </li>
      </ul>
    </div>
  </div>
</template>
<script>
export default {
  name: 'smartnavigationSystem',
};
</script>
<style scoped>
.smart-banner {
  width: 100%;
  height: 594px;
  background: #000;
}
.smart-banner div {
  overflow: hidden;
  width: 100%;
  height: 100%;
  background: url(../../../assets/img/smart/backgroundscenic_Image.png) no-repeat;
  background-size: cover;
}
.smart-banner h2 {
  margin-top: 182px;
  text-align: center;
  font-size: 100px;
  font-weight: bold;
  color: #fff;
}
.smart-banner h3 {
  text-align: center;
  font-size: 30px;
  font-weight: 400;
  color: #fff;
}
.smart-title {
  width: 100%;
  margin-top: 100px;
  margin-bottom: 100px;
  text-align: center;
  font-size: 60px;
  font-weight: bold;
  color: #000;
}
.smart-overview {
  width: 100%;
  height: 334px;
}
.smart-overview p {
  font-size: 18px;
  font-weight: 400;
  color: #666;
  text-indent: 2em;
  line-height: 1.8;
}
.smart-overview h2 {
  text-align: center;
  margin-bottom: 45px;
  font-size: 24px;
  font-weight: bold;
  color: #000;
}
.smart-strength {
  display: table;
  margin-right: -132px;
}
.smart-strength li {
  float: left;
  width: 366px;
  height: 160px;
  margin-right: 41px;
  margin-bottom: 50px;
}
.smart-strength li h2 {
  margin-bottom: 20px;
  font-size: 24px;
  font-weight: bold;
  color: #333;
}
.smart-strength li p {
  font-size: 18px;
  font-weight: 400;
  color: #333;
  line-height: 1.6;
}
</style>
